import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type {
    LearningOpportunityCompletionRequest,
    LearningOpportunityCompletionResponse,
} from '~/shared/data-contract/learning-opportunities';
import { learningOpportunityCompletionResponseSchema } from '~/shared/data-contract/learning-opportunities';

import { learningOpportunityPathnames } from './query-keys';

export const useCompleteLearningOpportunity = (
    id: string,
): UseMutationResult<LearningOpportunityCompletionResponse, Error, void> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const payload: LearningOpportunityCompletionRequest = {
        addSkillsToUser: true,
        generateUserCourseHistoryEntry: true,
    };

    return useMutation({
        mutationFn: async () => {
            const result = await validatingCobrainerApiFetcher.postJson(learningOpportunityCompletionResponseSchema, {
                pathname: `${learningOpportunityPathnames.detail(id)}/completion`,
                payload,
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
    });
};
